import { Users, Swords, Sparkles, Hammer } from "lucide-react";
import { Reveal } from "./Reveal";
import { DISCORD_URL } from "@/constants/links";

const STATS = [
  { icon: Users, n: "12", l: "Hratelných ras" },
  { icon: Swords, n: "21", l: "Hratelných povolání" },
  { icon: Sparkles, n: "100+", l: "Hratelných subclass" },
  { icon: Hammer, n: "9", l: "Výrobních profesí" },
];

export const Community = () => {
  return (
    <section
      id="komunita"
      className="relative scroll-mt-20 border-y border-white/10 px-6 py-20 lg:py-28"
      data-testid="community-section"
    >
      <div className="mx-auto max-w-[1584px] text-center">
        <Reveal>
          <h2 className="font-display text-3xl font-600 uppercase tracking-tight text-white sm:text-4xl">
            Staň se součástí příběhu
          </h2>
          <p className="mt-3 text-base text-white/55">
            Silná komunita dělá svět živým.
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-2 gap-10 lg:grid-cols-4">
          {STATS.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal
                key={s.l}
                delay={i * 0.08}
                className="flex flex-col items-center"
                data-testid={`stat-${i}`}
              >
                <Icon className="mb-4 h-8 w-8 text-white/40" strokeWidth={1.4} />
                <span className="font-display text-4xl font-700 text-[#F0801F] sm:text-5xl">
                  {s.n}
                </span>
                <span className="mt-2 font-display text-xs uppercase tracking-[0.16em] text-white/50">
                  {s.l}
                </span>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.2} className="mt-16">
          <a
            href={DISCORD_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="community-discord-btn"
            className="inline-flex items-center gap-2 rounded-md bg-[#F0801F] px-8 py-4 font-display text-sm font-600 uppercase tracking-[0.14em] text-[#141417] transition-colors hover:bg-[#ff9438]"
          >
            <i className="fa-brands fa-discord" />
            Discord
          </a>
        </Reveal>
      </div>
    </section>
  );
};
